import { useSyncExternalStore } from "react";
import EventQueue from "../store/event-queue.ts";

export default function useEventQueue() {
    return useSyncExternalStore(EventQueue.getInstance().subscribe, () => EventQueue.getInstance().queue);
}
